import { object, number, string, array, oneOf } from 'prop-types';
import { createPrefixedActionFactory } from './actionUtils';

const prefix = 'EDIT_DISH';
const createAction = createPrefixedActionFactory(prefix);

export const createNew = createAction({
  type: 'CREATE_NEW',
  propTypes: {
    itemId: string.isRequired,
    availability: object,
  },
});

export const startEditing = createAction({
  type: 'START_EDITING',
  propTypes: {
    orderItem: object.isRequired,
    cartIndex: number,
    origin: oneOf(['menuViewer', 'cart']).isRequired,
  },
});

export const edit = createAction({
  type: 'EDIT',
  propTypes: {
    orderItem: object.isRequired,
  },
});

export const changeCount = createAction({
  type: 'CHANGE_COUNT',
  propTypes: {
    count: number.isRequired,
  },
});

export const changeSpecialRequest = createAction({
  type: 'CHANGE_SPECIAL_REQUEST',
  propTypes: {
    specialRequestValue: string.isRequired,
  },
});

export const toggleChoice = createAction({
  type: 'TOGGLE_CHOICE',
  propTypes: {
    variationPath: array.isRequired,
    choiceId: string.isRequired,
  },
});

export const clear = createAction({
  type: 'CLEAR',
});
